const HEALTH_HOUSE_MEASUREMENT_DEFINITIONS = [
  {
    code: '30',
    labelKey: 'checkTypes.blood_pressure',
    results: [
      { key: 'systolic_bp', labelKey: 'checkTypes.systolic_bp', unit: 'mmHg' },
      { key: 'diastolic_bp', labelKey: 'checkTypes.diastolic_bp', unit: 'mmHg' },
      { key: 'pulse_rate', labelKey: 'checkTypes.pulse_rate', unit: 'bpm' }
    ]
  },
  {
    code: '40',
    labelKey: 'checkTypes.spo2',
    results: [
      { key: 'oxygen_saturation', labelKey: 'checkTypes.oxygen_saturation', unit: '%' },
      { key: 'pulse_rate', labelKey: 'checkTypes.pulse_rate', unit: 'bpm' }
    ]
  },
  {
    code: '50',
    labelKey: 'checkTypes.temperature',
    results: [
      { key: 'temperature', labelKey: 'checkTypes.temperature', unit: '°C' }
    ]
  },
  {
    code: '90',
    labelKey: 'checkTypes.body_height_weight',
    results: [
      { key: 'height', labelKey: 'checkTypes.height', unit: 'cm' },
      { key: 'weight', labelKey: 'checkTypes.weight', unit: 'kg' },
      { key: 'bmi', labelKey: 'checkTypes.bmi', unit: '' }
    ]
  },
  {
    code: '180',
    labelKey: 'checkTypes.body_composition',
    results: [
      { key: 'body_fat_ratio', labelKey: 'checkTypes.body_fat_ratio', unit: '%' }
    ]
  },
  {
    code: '20',
    labelKey: 'checkTypes.blood_glucose',
    results: [
      { key: 'blood_glucose', labelKey: 'checkTypes.blood_glucose', unit: 'mmol/L' }
    ]
  },
  {
    code: '70',
    labelKey: 'checkTypes.hemoglobin',
    results: [
      { key: 'hemoglobin', labelKey: 'checkTypes.hemoglobin', unit: 'g/L' }
    ]
  },
  {
    code: '210',
    labelKey: 'checkTypes.uric_acid',
    results: [
      { key: 'uric_acid', labelKey: 'checkTypes.uric_acid', unit: 'μmol/L' }
    ]
  },
  {
    code: '130',
    labelKey: 'checkTypes.cholesterol',
    results: [
      { key: 'cholesterol', labelKey: 'checkTypes.cholesterol', unit: 'mmol/L' }
    ]
  },
  {
    code: '131',
    labelKey: 'checkTypes.lipid_panel',
    results: [
      { key: 'total_cholesterol', labelKey: 'checkTypes.total_cholesterol', unit: 'mmol/L' },
      { key: 'triglycerides', labelKey: 'checkTypes.triglycerides', unit: 'mmol/L' },
      { key: 'hdl_cholesterol', labelKey: 'checkTypes.hdl_cholesterol', unit: 'mmol/L' },
      { key: 'ldl_cholesterol', labelKey: 'checkTypes.ldl_cholesterol', unit: 'mmol/L' }
    ]
  },
  {
    code: '220',
    labelKey: 'checkTypes.urine_glucose',
    results: [
      { key: 'urine_glucose', labelKey: 'checkTypes.urine_glucose', unit: 'mmol/L' }
    ]
  }
];

const DEFINITION_BY_CODE = new Map(
  HEALTH_HOUSE_MEASUREMENT_DEFINITIONS.map((definition, index) => [
    definition.code,
    { ...definition, sortOrder: index }
  ])
);

const hasValue = (value) => value !== undefined && value !== null && String(value).trim() !== '';

const getResultSource = (measurement) => {
  const normalizedResults = measurement?.normalized_results;
  if (normalizedResults && Object.keys(normalizedResults).length > 0) {
    return normalizedResults;
  }
  return measurement?.parsed_vital_signs || {};
};

const getMeasurementTimestamp = (measurement) => (
  measurement.completed_at ||
  measurement.callback_received_at ||
  measurement.updated_at ||
  measurement.created_at ||
  ''
);

export const buildHealthHouseCheckRows = (measurements = [], t = (key) => key) => (
  measurements
    .filter((measurement) => measurement?.status === 'completed')
    .map((measurement) => {
      const code = String(measurement.measurement_type_code || '').trim();
      const definition = DEFINITION_BY_CODE.get(code);
      const resultSource = getResultSource(measurement);
      const results = (definition?.results || [])
        .filter((resultDefinition) => hasValue(resultSource[resultDefinition.key]))
        .map((resultDefinition) => ({
          key: resultDefinition.key,
          label: t(resultDefinition.labelKey),
          value: String(resultSource[resultDefinition.key]).trim(),
          unit: resultDefinition.unit
        }));

      return {
        id: measurement.id,
        code,
        itemName: definition ? t(definition.labelKey) : `${t('reports.healthHouseUnknownItem')} ${code}`.trim(),
        checkedAt: getMeasurementTimestamp(measurement),
        results,
        sortOrder: definition?.sortOrder ?? Number.MAX_SAFE_INTEGER
      };
    })
    .filter((row) => row.results.length > 0)
    .sort((left, right) => left.sortOrder - right.sortOrder)
);

export const formatHealthHouseResultValue = (result) => (
  result.unit ? `${result.value} ${result.unit}` : result.value
);

export { HEALTH_HOUSE_MEASUREMENT_DEFINITIONS };
